import {WixSdk} from '@wix/js-sdk-wrapper';
import {map, startWith} from 'rxjs/operators';
import {subscribe} from './wixSdkObservables';

export enum ViewModes {
  Editor = 'editor',
  Preview = 'preview',
  Site = 'site',
  Standalone = 'standalone',
}

export function getViewMode() {
  return WixSdk.Utils.getViewMode() as ViewModes;
}

export function isInEditor() {
  return getViewMode() === ViewModes.Editor;
}

export function isInPreview() {
  return getViewMode() === ViewModes.Preview;
}

export function isInSite() {
  return getViewMode() === ViewModes.Site;
}

export const viewMode$ = subscribe<{editMode: ViewModes}>(WixSdk.Events.EDIT_MODE_CHANGE).pipe(
  map((e) => e.editMode),
  startWith(getViewMode()),
);
